module.exports = __webpack_public_path__ + "img/email-verify-dark.b82443ac.svg";